import { AppHeaderContext } from '@deltek/specification-client/core/Contexts/AppHeaderContext'
import Typography from '@material-ui/core/Typography'
import React, { useEffect } from 'react'

const UserProfilePage: React.FC = () => {
    const { updateAppHeaderContent } = React.useContext(AppHeaderContext)

    useEffect(() => {
        updateAppHeaderContent('User Profile')
    }, [updateAppHeaderContent])
    return (
        <Typography variant="h1">
            This is a placeholder for the User Profile page.
        </Typography>
    )
}

export default UserProfilePage
